import { Translated } from '@app-types/common.types'
import { CategoryFragment } from '@app-graphql/schema'
import {
    filtersConfigForDiningTables,
    PRODUCT_LIST_FILTERS_ORDER_CONFIG,
    ProductListFilterEnum,
} from '@app-domains/product-list/types'

// Category names that use a non-standard filter config
const filtersConfigMapping: Record<string, ProductListFilterEnum[]> = {
    eettafels: filtersConfigForDiningTables,
}

export const resolveFiltersConfig = (category: Translated<CategoryFragment>): ProductListFilterEnum[] => {
    const dutchCategoryName = category.translations?.nl?.name?.toLowerCase() ?? ''

    return filtersConfigMapping[dutchCategoryName] || PRODUCT_LIST_FILTERS_ORDER_CONFIG
}
